import React from "react";

interface CardGridProps {
  children: React.ReactNode;
  emptyMessage?: string;
  emptySubtext?: string;
}

const CardGrid: React.FC<CardGridProps> = ({
  children,
  emptyMessage = "No items found.",
  emptySubtext,
}) => {
  const hasContent = React.Children.count(children) > 0;

  if (!hasContent) {
    return (
      <div className="no-services">
        <p>{emptyMessage}</p>
        {emptySubtext && <p>{emptySubtext}</p>}
      </div>
    );
  }

  return <div className="services-list">{children}</div>;
};

export default CardGrid;
